'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialFoursquare = function IoSocialFoursquare(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.5 2.5c2.7 0 3.5 1.6 2.8 4.5-0.7 3.8-3.1 15.7-3.3 16.6-0.2 1-0.6 2.7-3.1 2.7h-5.6c-0.2 0-0.2 0-0.5 0.2-0.1 0.1-8.9 10.4-8.9 10.4-0.7 0.8-1.8 0.6-2.2 0.4s-1.2-0.6-1.2-2v-29.7s0.8-3.1 3.4-3.1h18.6z m-0.5 21.1c0.2-0.9 2.6-12.8 3.3-16.6z m-0.6-16c0.1-0.7-0.4-1.3-1-1.3h-14.9c-0.7 0-1.2 0.7-1.2 1.2v23.1c0 0.1 0.1 0.1 0.2 0 0 0 5.5-6.5 6.1-7.3s0.8-0.9 1.8-0.9h5c0.7 0 1.1-0.6 1.1-0.9s0.7-3.4 0.8-4-0.4-1.2-1-1.2h-6.4c-0.8 0-1.4-0.7-1.4-1.5v-1c0-0.8 0.6-1.3 1.4-1.3h7.5s1.1-0.5 1.2-0.9z' })
        )
    );
};

exports.default = IoSocialFoursquare;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-foursquare.js
// module id = 2469
// module chunks = 0